export function FooterNotFound() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="overflow-hidden w-full h-10 flex flex-col mobile-m:h-14">
      <hr className="mx-4 my-0 max-w-desktop h-px flex-shrink-0 bg-gray-100 border-none tablet:mx-10 mobile-m:w-full desktop:mx-20 desktop-l:mx-auto" />
      <div className="container flex flex-1 flex-col justify-center">
        <small className="text-sm text-black leading-none">
          © {currentYear} PURE
        </small>
      </div>
    </footer>
  )
}
